import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import LayoutSizes from '../enums/layout/layoutSizes';
import LayoutTypes from '../enums/layout/layoutTypes';
import useWindowResize from '../hooks/useWindowResize';
import userDeviceService from '../services/user/userDeviceService';
import {setLayout} from '../state/ducks/global';
import {selectLayoutType} from '../state/selectors/global';

const useLayoutChange = () => {
    const layoutType = useSelector(selectLayoutType);
    const dispatch = useDispatch();
    const isTabletIOSDevice = userDeviceService.isTabletIOSDevice();
    const getSize = () => ({
        // use window.screen.width for iOS tablets to get the correct device width
        // more information is here https://stackoverflow.com/questions/4629969/ios-return-bad-value-for-window-innerheight-width
        width: isTabletIOSDevice ? window.screen.width : window.innerWidth,
        height: window.innerHeight,
    });
    const [windowSize, setWindowSize] = useState(getSize());
    const onResize = () => setWindowSize(getSize());
    const currentLayout = getLayout(windowSize.width);

    useWindowResize(onResize);
    useEffect(() => {
        if (layoutType !== currentLayout) {
            dispatch(setLayout(currentLayout));
        }
    }, [layoutType, currentLayout]);
};

const getLayout = (deviceWidth) => {
    if (deviceWidth < LayoutSizes.SM) {
        return LayoutTypes.SM;
    } else if (deviceWidth < LayoutSizes.TABLET) {
        return LayoutTypes.MOBILE;
    } else if (deviceWidth >= LayoutSizes.DESKTOP) {
        return LayoutTypes.DESKTOP;
    } else {
        return LayoutTypes.TABLET;
    }
};

export default useLayoutChange;
